define("checkout/components/seamless-checkout/trial-plans-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "later/utils/constants", "shared/utils/compare-strings", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _constants, _compareStrings, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/constants",0,"shared/utils/compare-strings",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.isSimplifiedVariant}}
    <Shared::Modal
      @closable={{this.canCloseModal}}
      @close={{this.closeTrialPlansModal}}
      @focusTrap={{true}}
      class=""
      as |modal|
    >
      <modal.card
        @portrait={{false}}
        class="tCK--modalCard tPF--modalCard__trial"
        {{track "viewed-page" page="seamless_plan_snapshot"}}
      >
        <modal.card-header class="u--p__b__sm u--text--center">
          <h2 class="o--modalHeader__title u--text--lg">{{t "authorization.sign_up_trial.page_title"}}</h2>
          <p class="u--text--light u--m__tb__sm">{{t "authorization.sign_up_trial.sub_title"}}</p>
        </modal.card-header>
        <modal.card-body class="u--p__t__0">
          {{! Scheduling Tools }}
          <ul class="tCK--features u--fadeIn">
            <li class="tCK--features__item">
              {{svg-jar "instant" class="o--icon tCK--features__icon"}}
              <p class="tCK--features__title">{{t "plans.feature_highlights.auto_publish"}}</p>
            </li>
            <li class="tCK--features__item">
              {{svg-jar "bttp" class="o--icon tCK--features__icon"}}
              <p class="tCK--features__title">{{t "plans.feature_highlights.bttp"}}</p>
            </li>
            <li class="tCK--features__item">
              {{svg-jar "preview" class="o--icon tCK--features__icon"}}
              <p class="tCK--features__title">{{t "plans.feature_highlights.preview"}}</p>
            </li>
            <li class="tCK--features__item">
              {{svg-jar "ig-reels-outline" class="o--icon tCK--features__icon"}}
              <p class="tCK--features__title">{{t "plans.feature_highlights.reels"}}</p>
            </li>
            <li class="tCK--features__item">
              {{svg-jar "smart-hashtag" class="o--icon tCK--features__icon"}}
              <p class="tCK--features__title">{{t "plans.feature_highlights.hashtag_suggestions"}}</p>
            </li>
            <li class="tCK--features__item">
              {{svg-jar "ig-story-add" class="o--icon tCK--features__icon"}}
              <p class="tCK--features__title">{{t "plans.feature_highlights.stories"}}</p>
            </li>
            <li class="tCK--features__item">
              {{svg-jar "ml" class="o--icon tCK--features__icon"}}
              <p class="tCK--features__title">{{t "plans.feature_highlights.carousels"}}</p>
            </li>
          </ul>
          {{! Plan Cards }}
          <section class="tCK--plan u--m__t__0">
            {{#each this.trialOptInPlans as |plan|}}
              <SeamlessCheckout::PlanCard
                @isSimplifiedVariant={{this.isSimplifiedVariant}}
                @onPlanButtonClick={{fn this.handleSelectedPlan plan.planType}}
                @plan={{plan}}
                @toggleEnterpriseModal={{toggle-action "showEnterprisePlanModal" this}}
              />
            {{/each}}
          </section>
        </modal.card-body>
      </modal.card>
    </Shared::Modal>
  {{else}}
    <Shared::Modal
      @closable={{this.canCloseModal}}
      @close={{this.closeTrialPlansModal}}
      @closeButtonQaClass="qa--trial_snapshot_close_btn"
      @focusTrap={{true}}
      @onAttemptedClose={{this.alertTrialStartInProgress}}
      class=""
      as |modal|
    >
      <modal.card
        @portrait={{false}}
        class="tPF--modalCard tPF--modalCard__trial"
        {{track "viewed-page" page="seamless_plan_snapshot"}}
      >
        <modal.card-header class="u--p__b__sm">
          <p class="o--modalHeader__title">{{t "authorization.sign_up_trial.page_title"}}</p>
          {{#if this.isSourcelessTrialABTest}}
            <p class="u--text--light u--m__tb__sm">{{t "authorization.sign_up_trial.card_less_trial_sub_title"}}</p>
          {{else}}
            <p class="u--text--light">{{t "authorization.sign_up_trial.sub_title"}}</p>
          {{/if}}
        </modal.card-header>
        <modal.card-body class="u--p__t__0">
          <section class="tPF--planWrapper">
            <div class="tPF--plan tPF--plan—-sm u--m__t__0">
              {{#each this.trialOptInPlans as |plan|}}
                <SeamlessCheckout::PlanCard
                  @isSourcelessTrial={{this.isSourcelessTrialABTest}}
                  @isTrialStartInProgress={{this.isTrialStartInProgress}}
                  @onPlanButtonClick={{fn this.handleSelectedPlan plan.planType}}
                  @plan={{plan}}
                  @sourcelessTrialSelectedPlanType={{this.planType}}
                  @startSourcelessTrial={{fn this.startSourcelessTrial plan.planType}}
                />
              {{/each}}
            </div>
          </section>
        </modal.card-body>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  
  {{#if this.showEnterprisePlanModal}}
    <Shared::EnterpriseModal @closeModal={{toggle-action "showEnterprisePlanModal" this}} />
  {{/if}}
  */
  {
    "id": "jjbVUlqk",
    "block": "[[[41,[30,0,[\"isSimplifiedVariant\"]],[[[1,\"  \"],[8,[39,1],[[24,0,\"\"]],[[\"@closable\",\"@close\",\"@focusTrap\"],[[30,0,[\"canCloseModal\"]],[30,0,[\"closeTrialPlansModal\"]],true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card\"]],[[24,0,\"tCK--modalCard tPF--modalCard__trial\"],[4,[38,2],[\"viewed-page\"],[[\"page\"],[\"seamless_plan_snapshot\"]]]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__sm u--text--center\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title u--text--lg\"],[12],[1,[28,[35,3],[\"authorization.sign_up_trial.page_title\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--m__tb__sm\"],[12],[1,[28,[35,3],[\"authorization.sign_up_trial.sub_title\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"        \"],[10,\"ul\"],[14,0,\"tCK--features u--fadeIn\"],[12],[1,\"\\n          \"],[10,\"li\"],[14,0,\"tCK--features__item\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"instant\"],[[\"class\"],[\"o--icon tCK--features__icon\"]]]],[1,\"\\n            \"],[10,2],[14,0,\"tCK--features__title\"],[12],[1,[28,[35,3],[\"plans.feature_highlights.auto_publish\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"tCK--features__item\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"bttp\"],[[\"class\"],[\"o--icon tCK--features__icon\"]]]],[1,\"\\n            \"],[10,2],[14,0,\"tCK--features__title\"],[12],[1,[28,[35,3],[\"plans.feature_highlights.bttp\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"tCK--features__item\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"preview\"],[[\"class\"],[\"o--icon tCK--features__icon\"]]]],[1,\"\\n            \"],[10,2],[14,0,\"tCK--features__title\"],[12],[1,[28,[35,3],[\"plans.feature_highlights.preview\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"tCK--features__item\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"ig-reels-outline\"],[[\"class\"],[\"o--icon tCK--features__icon\"]]]],[1,\"\\n            \"],[10,2],[14,0,\"tCK--features__title\"],[12],[1,[28,[35,3],[\"plans.feature_highlights.reels\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"tCK--features__item\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"smart-hashtag\"],[[\"class\"],[\"o--icon tCK--features__icon\"]]]],[1,\"\\n            \"],[10,2],[14,0,\"tCK--features__title\"],[12],[1,[28,[35,3],[\"plans.feature_highlights.hashtag_suggestions\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"tCK--features__item\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"ig-story-add\"],[[\"class\"],[\"o--icon tCK--features__icon\"]]]],[1,\"\\n            \"],[10,2],[14,0,\"tCK--features__title\"],[12],[1,[28,[35,3],[\"plans.feature_highlights.stories\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"tCK--features__item\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"ml\"],[[\"class\"],[\"o--icon tCK--features__icon\"]]]],[1,\"\\n            \"],[10,2],[14,0,\"tCK--features__title\"],[12],[1,[28,[35,3],[\"plans.feature_highlights.carousels\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,\"section\"],[14,0,\"tCK--plan u--m__t__0\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"trialOptInPlans\"]]],null]],null],null,[[[1,\"            \"],[8,[39,7],null,[[\"@isSimplifiedVariant\",\"@onPlanButtonClick\",\"@plan\",\"@toggleEnterpriseModal\"],[[30,0,[\"isSimplifiedVariant\"]],[28,[37,8],[[30,0,[\"handleSelectedPlan\"]],[30,2,[\"planType\"]]],null],[30,2],[28,[37,9],[\"showEnterprisePlanModal\",[30,0]],null]]],null],[1,\"\\n\"]],[2]],null],[1,\"        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,1],[[24,0,\"\"]],[[\"@closable\",\"@close\",\"@closeButtonQaClass\",\"@focusTrap\",\"@onAttemptedClose\"],[[30,0,[\"canCloseModal\"]],[30,0,[\"closeTrialPlansModal\"]],\"qa--trial_snapshot_close_btn\",true,[30,0,[\"alertTrialStartInProgress\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card\"]],[[24,0,\"tPF--modalCard tPF--modalCard__trial\"],[4,[38,2],[\"viewed-page\"],[[\"page\"],[\"seamless_plan_snapshot\"]]]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,3,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,3],[\"authorization.sign_up_trial.page_title\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"isSourcelessTrialABTest\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--light u--m__tb__sm\"],[12],[1,[28,[35,3],[\"authorization.sign_up_trial.card_less_trial_sub_title\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[14,0,\"u--text--light\"],[12],[1,[28,[35,3],[\"authorization.sign_up_trial.sub_title\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n      \"],[8,[30,3,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"section\"],[14,0,\"tPF--planWrapper\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tPF--plan tPF--plan—-sm u--m__t__0\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"trialOptInPlans\"]]],null]],null],null,[[[1,\"              \"],[8,[39,7],null,[[\"@isSourcelessTrial\",\"@isTrialStartInProgress\",\"@onPlanButtonClick\",\"@plan\",\"@sourcelessTrialSelectedPlanType\",\"@startSourcelessTrial\"],[[30,0,[\"isSourcelessTrialABTest\"]],[30,0,[\"isTrialStartInProgress\"]],[28,[37,8],[[30,0,[\"handleSelectedPlan\"]],[30,4,[\"planType\"]]],null],[30,4],[30,0,[\"planType\"]],[28,[37,8],[[30,0,[\"startSourcelessTrial\"]],[30,4,[\"planType\"]]],null]]],null],[1,\"\\n\"]],[4]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,0,[\"showEnterprisePlanModal\"]],[[[1,\"  \"],[8,[39,10],null,[[\"@closeModal\"],[[28,[37,9],[\"showEnterprisePlanModal\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null]],[\"modal\",\"plan\",\"modal\",\"plan\"],false,[\"if\",\"shared/modal\",\"track\",\"t\",\"svg-jar\",\"each\",\"-track-array\",\"seamless-checkout/plan-card\",\"fn\",\"toggle-action\",\"shared/enterprise-modal\"]]",
    "moduleName": "checkout/components/seamless-checkout/trial-plans-modal.hbs",
    "isStrictMode": false
  });
  let TrialPlansModalComponent = _exports.default = (_class = class TrialPlansModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "trialOptInPlanNames", ['starter202506', 'growth202506', 'scale202506']);
      _defineProperty(this, "trialOptInPlanMobileNames", ['starter202506', 'growth202506']);
      _initializerDefineProperty(this, "showEnterprisePlanModal", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "alerts", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "events", _descriptor5, this);
      _initializerDefineProperty(this, "intl", _descriptor6, this);
      _initializerDefineProperty(this, "payment", _descriptor7, this);
      _initializerDefineProperty(this, "plans", _descriptor8, this);
      _initializerDefineProperty(this, "router", _descriptor9, this);
      _initializerDefineProperty(this, "segment", _descriptor10, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor11, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor12, this);
      _initializerDefineProperty(this, "userAgent", _descriptor13, this);
      _initializerDefineProperty(this, "planType", _descriptor14, this);
      _initializerDefineProperty(this, "isTrialStartInProgress", _descriptor15, this);
      _defineProperty(this, "onAccountUpdated", () => {
        if (this.subscriptions.subscriptionPlan?.planType === this.planType) {
          this.isTrialStartInProgress = false;
          this.seamlessCheckoutManager.canCloseCheckoutModal = true;
          this.seamlessCheckoutManager.closeModal();
          this.seamlessCheckoutManager.openCheckoutSuccessModal();
        }
      });
    }
    get canCloseModal() {
      return this.seamlessCheckoutManager.canCloseCheckoutModal;
    }
    get isSimplifiedVariant() {
      return (0, _compareStrings.areStringsEqual)(this.auth.currentAccount?.experiments?.['web_in-app-plan-snapshot_simplified'], 'new-design');
    }
    get isSourcelessTrialABTest() {
      return this.auth.currentAccount?.rolloutSourcelessTrial;
    }
    get trialOptInPlans() {
      const planNames = this.userAgent.device.isMobile && !this.isSimplifiedVariant ? this.trialOptInPlanMobileNames : this.trialOptInPlanNames;
      return this.plans.plans.filter(plan => planNames.includes(plan.planType));
    }
    willDestroy() {
      super.willDestroy();
      this.events.off('account:updated', this.onAccountUpdated);
    }
    handleSelectedPlan(planType) {
      if (planType === 'enterprise') {
        this.showEnterprisePlanModal = true;
        this.segment.track('clicked-enterprise-contact-button');
      } else if (this.router.currentRouteName == 'plans.trial_plans') {
        //Note: this edge case is needed until plans/trial_plans route is removed.
        this.router.transitionTo('plans.plan', planType);
      } else {
        this.seamlessCheckoutManager.openCheckoutModal(planType, {
          // Note: When switching between the checkout and trial plans modal, we want to retain
          // the same state, otherwise this gets unset in the service
          canCloseCheckoutModal: this.seamlessCheckoutManager.canCloseCheckoutModal
        });
      }
    }
    async startSourcelessTrial(planType) {
      try {
        this.planType = planType;
        this.isTrialStartInProgress = true;
        this.seamlessCheckoutManager.canCloseCheckoutModal = false;
        const stripePlanId = await this.subscriptions.getSubscriptionPlanStripeId(planType);
        this.events.on('account:updated', this.onAccountUpdated);
        await this.payment.startSourcelessTrial.perform(stripePlanId, _constants.TRIAL_TYPES.sourcelessTrial);
      } catch (error) {
        this.errors.log(error);
      }
    }
    closeTrialPlansModal() {
      this.segment.track('declined-trial-offer', {
        location: 'seamless_plan_checkout'
      });
      this.seamlessCheckoutManager.closeModal();
    }
    alertTrialStartInProgress() {
      if (!this.seamlessCheckoutManager.canCloseCheckoutModal && this.seamlessCheckoutManager.isCheckoutInProgress) {
        this.alerts.info('', {
          title: this.intl.t('alerts.plans.checkout.checkout_in_progress')
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "showEnterprisePlanModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "events", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "planType", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "isTrialStartInProgress", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleSelectedPlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSelectedPlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startSourcelessTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "startSourcelessTrial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTrialPlansModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTrialPlansModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertTrialStartInProgress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "alertTrialStartInProgress"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TrialPlansModalComponent);
});